import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { programs } from '@/mocks/neurobaby';

const yogaMovements = [
  {
    id: 1,
    name: 'Respiración sincronizada mamá-bebé',
    duration: '2 minutos',
    icon: 'ri-windy-line',
    description: 'Sentáte en una superficie cómoda con tu bebé en tu regazo, su espalda apoyada contra tu pecho. Colocá una mano sobre tu corazón y la otra sobre el pecho de tu bebé. Cerrá los ojos. Inhalá contando hasta cuatro, sentí cómo tu pecho eleva suavecito al bebé. Exhalá por la boca, más lento, hasta seis. Repetí seis veces. No hace falta que tu bebé "haga" nada. Solo sentí que respirás juntos, que su espalda sube y baja con la tuya.',
    science: 'Cuando respiramos consciente y lentamente, activamos el nervio vago, el gran conductor del sistema parasimpático. Esa respiración lenta envía una señal directa al cerebro del bebé: "estamos seguros, podemos bajar la guardia". Daniel Siegel lo llama co-regulación: tu sistema nervioso calmado regula el de tu bebé como si fueran una misma orquesta.',
    image: 'https://readdy.ai/api/search-image?query=Digital%20art%20illustration%20in%20the%20style%20of%20premium%20editorial%20magazine%20cover%2C%20hyperrealistic%20digital%20render%20with%20soft%20painterly%20brush%20strokes%2C%20warm%20golden%20earth%20tones%2C%20soft%20textured%20lighting%2C%20a%20real%20mother%20sitting%20cross-legged%20on%20a%20soft%20mat%20with%20her%20baby%20resting%20against%20her%20chest%2C%20both%20with%20eyes%20closed%20in%20peaceful%20breathing%2C%20warm%20cream%20and%20terracotta%20color%20palette%2C%20mother%20hand%20gently%20placed%20on%20baby%20chest%2C%20soft%20natural%20window%20light%2C%20artistic%20yet%20photorealistic%2C%20editorial%20premium%20quality%2C%20not%20a%20stock%20photo%2C%20not%20cold%20or%20clinical%2C%20warm%20neutral%20palette%2C%20intimate%20mindfulness%20moment%2C%20authentic%20connection%2C%20soft%20linen%20textures&width=800&height=500&seq=301&orientation=landscape',
  },
  {
    id: 2,
    name: 'Abrazo canguro en posición sentada',
    duration: '1 minuto 30 segundos',
    icon: 'ri-heart-3-line',
    description: 'Deslizá a tu bebé para que quede sobre tu pecho, su cabecita recostada en el hueco de tu clavícula. Rodealo con tus brazos como si fuera el capullo más suave del mundo. Acariciá su espalda con movimientos lentos, de arriba hacia abajo. No hables. No cantes. Solo dejá que tu corazón le hable. Sentí el calor que intercambian sus pielecitas. Esto es contacto piel con piel, aunque haya ropa fina de por medio. El amor atraviesa todo.',
    science: 'El contacto piel con piel estimula la liberación de oxitocina, la hormona del vínculo, tanto en mamá como en bebé. Esta hormona inhibe la producción de cortisol, la hormona del estrés. Desde el punto de vista neurocientífico, el cuerpo de tu bebé está literalmente "aprendiendo" a sentirse seguro a través de la proximidad física. Tu olor, tu temperatura, el sonido de tu corazón: son datos sensoriales que su cerebro interpreta como "estoy protegido".',
    image: 'https://readdy.ai/api/search-image?query=Digital%20art%20illustration%20in%20the%20style%20of%20premium%20editorial%20magazine%20cover%2C%20hyperrealistic%20digital%20render%20with%20soft%20painterly%20brush%20strokes%2C%20warm%20golden%20earth%20tones%2C%20soft%20textured%20lighting%2C%20a%20real%20mother%20sitting%20in%20a%20cozy%20armchair%20holding%20her%20baby%20close%20in%20a%20kangaroo%20embrace%2C%20baby%20head%20resting%20on%20mother%20collarbone%2C%20warm%20cream%20and%20terracotta%20color%20palette%2C%20soft%20golden%20afternoon%20light%2C%20mother%20arms%20wrapped%20protectively%20around%20baby%2C%20peaceful%20and%20tender%20atmosphere%2C%20artistic%20yet%20photorealistic%2C%20editorial%20premium%20quality%2C%20not%20a%20stock%20photo%2C%20not%20cold%20or%20clinical%2C%20warm%20neutral%20palette%2C%20intimate%20skin%20to%20skin%20connection%2C%20authentic%20motherhood%20moment%2C%20soft%20textures&width=800&height=500&seq=302&orientation=landscape',
  },
  {
    id: 3,
    name: 'Masaje suave en espalda del bebé',
    duration: '2 minutos',
    icon: 'ri-hand-heart-line',
    description: 'Acostá a tu bebé boca abajo sobre tus piernas, con un mantita suave debajo. Poné un poquito de aceite de almendras o coco en tus manos, frotalas para calentarlo. Empezá desde la nuca, con la yema de los dedos, haciendo círculos diminutos y lentos. Bajá por la columna, siempre hacia abajo, nunca al revés. En la zona de los omóplatos, hacé pequeñas presiones como si estuvieras dibujando un corazón. Tu bebé puede gemir, suspirar, o quedar completamente quieto. Todas las respuestas son correctas.',
    science: 'El masaje en la espalda activa los receptores táctiles C-táctiles, fibras nerviosas específicas que responden al toque suave y lento. Estas fibras se conectan directamente con las áreas del cerebro que procesan emociones y bienestar. Estimularlas reduce la frecuencia cardíaca, baja la presión arterial y promueve la liberación de serotonina. Para tu bebé, tu mano sobre su espalda es mapa de seguridad: cada célula sabe que está acompañado.',
    image: 'https://readdy.ai/api/search-image?query=Digital%20art%20illustration%20in%20the%20style%20of%20premium%20editorial%20magazine%20cover%2C%20hyperrealistic%20digital%20render%20with%20soft%20painterly%20brush%20strokes%2C%20warm%20golden%20earth%20tones%2C%20soft%20textured%20lighting%2C%20a%20real%20mother%20gently%20massaging%20her%20baby%20back%20while%20baby%20lies%20face%20down%20on%20her%20lap%2C%20soft%20warm%20blanket%20underneath%2C%20warm%20cream%20and%20terracotta%20color%20palette%2C%20mother%20hands%20making%20small%20circles%20on%20baby%20back%2C%20intimate%20and%20peaceful%20nursery%20scene%2C%20soft%20natural%20light%2C%20artistic%20yet%20photorealistic%2C%20editorial%20premium%20quality%2C%20not%20a%20stock%20photo%2C%20not%20cold%20or%20clinical%2C%20warm%20neutral%20palette%2C%20tender%20touch%20and%20care%2C%20authentic%20motherhood%20moment%2C%20soft%20textures&width=800&height=500&seq=303&orientation=landscape',
  },
  {
    id: 4,
    name: 'Balanceo lateral con bebé en brazos',
    duration: '1 minuto 30 segundos',
    icon: 'ri-exchange-line',
    description: 'Parate con los pies separados al ancho de tus caderas. Sostené a tu bebé contra tu pecho, una mano bajo su cabecita, la otra en su colita. Empezá a mecerlos suavemente de lado a lado, como si fuera un vals lento. El movimiento viene de tu cintura, no de los brazos. Dejá que tu cuerpo se relaje. Si se te ocurre, cantá una canción muy bajito. O silbá. O no hagas ningún sonido. Lo que tu instinto te diga en este momento, eso es lo correcto.',
    science: 'El movimiento rítmico lateral activa el sistema vestibular del bebé, localizado en el oído interno, que es responsable del equilibrio y la sensación de orientación espacial. Cuando movemos al bebé de forma rítmica y predecible, el cerebelo recibe señales de que el cuerpo está en movimiento controlado, lo que reduce la alerta y facilita la transición hacia estados de calma. Es la misma razón por la que los bebés se duermen en el auto: el movimiento rítmico es un lenguaje ancestral que el cerebro entiende perfectamente.',
    image: 'https://readdy.ai/api/search-image?query=Digital%20art%20illustration%20in%20the%20style%20of%20premium%20editorial%20magazine%20cover%2C%20hyperrealistic%20digital%20render%20with%20soft%20painterly%20brush%20strokes%2C%20warm%20golden%20earth%20tones%2C%20soft%20textured%20lighting%2C%20a%20real%20mother%20standing%20and%20gently%20swaying%20side%20to%20side%20with%20her%20baby%20held%20close%20to%20her%20chest%2C%20soft%20movement%20blur%2C%20warm%20cream%20and%20terracotta%20color%20palette%2C%20peaceful%20living%20room%20with%20natural%20light%2C%20mother%20and%20baby%20in%20slow%20dance%20motion%2C%20artistic%20yet%20photorealistic%2C%20editorial%20premium%20quality%2C%20not%20a%20stock%20photo%2C%20not%20cold%20or%20clinical%2C%20warm%20neutral%20palette%2C%20rhythmic%20comfort%20and%20safety%2C%20authentic%20tender%20moment%2C%20soft%20linen%20textures&width=800&height=500&seq=304&orientation=landscape',
  },
  {
    id: 5,
    name: 'Postura de cierre — recostadas juntas',
    duration: '2 minutos',
    icon: 'ri-moon-line',
    description: 'Acostáte sobre tu costado en un lugar cómodo, la cama, el sofá, un piso con almohadas. Acostá a tu bebé frente a vos, su nariz casi tocando la tuya. Poné una mano sobre su cadera. Cerrá los ojos y sentí su respiración. No pienses en lo que viene después. No pienses en lo que deberías estar haciendo. Solo estás acá. Con tu bebé. Esto es suficiente. Esto es perfecto. Esto es todo.',
    science: 'Esta posición de face-to-face, en contacto cercano y quieto, maximiza lo que la neurociencia del apego llama "sincronía biobehavioral": la alineación natural de los ritmos biológicos entre mamá y bebé. Cuando estás quieta y relajada, tu frecuencia cardíaca baja, y la de tu bebé la sigue. Tu temperatura se estabiliza, y la suya también. Es la postura más poderosa de todas: no porque "haga" algo, sino porque permite que el cuerpo de tu bebé sienta, en cada célula, que no está solo.',
    image: 'https://readdy.ai/api/search-image?query=Digital%20art%20illustration%20in%20the%20style%20of%20premium%20editorial%20magazine%20cover%2C%20hyperrealistic%20digital%20render%20with%20soft%20painterly%20brush%20strokes%2C%20warm%20golden%20earth%20tones%2C%20soft%20textured%20lighting%2C%20a%20real%20mother%20and%20baby%20lying%20side%20by%20side%20on%20a%20soft%20bed%20facing%20each%20other%2C%20eyes%20closed%2C%20noses%20almost%20touching%2C%20warm%20cream%20and%20terracotta%20color%20palette%2C%20soft%20evening%20light%2C%20peaceful%20and%20intimate%20bedroom%20scene%2C%20mother%20hand%20resting%20gently%20on%20baby%20hip%2C%20artistic%20yet%20photorealistic%2C%20editorial%20premium%20quality%2C%20not%20a%20stock%20photo%2C%20not%20cold%20or%20clinical%2C%20warm%20neutral%20palette%2C%20quiet%20connection%20and%20rest%2C%20authentic%20tender%20moment%2C%20soft%20linen%20textures%2C%20cozy%20atmosphere&width=800&height=500&seq=305&orientation=landscape',
  },
];

const breathingSteps = [
  { name: 'Inhalá', duration: 4000, instruction: 'Por la nariz, contando hasta 4. Sentí cómo tu pecho eleva suavemente a tu bebé.' },
  { name: 'Mantené', duration: 4000, instruction: 'Retené el aire suavemente. Sin forzar. Tu bebé siente tu calma.' },
  { name: 'Exhalá', duration: 6000, instruction: 'Por la boca, lenta y completamente. Solitá la tensión de los hombros.' },
  { name: 'Descansá', duration: 2000, instruction: 'Pausa. Sentí el momento de quietud. Tu bebé ya está un poco más relajado.' },
];

export default function RutinaRelajacion() {
  const [activeMovement, setActiveMovement] = useState(0);
  const { t } = useTranslation();
  const [breathStep, setBreathStep] = useState(0);
  const [breathActive, setBreathActive] = useState(false);
  const [breathProgress, setBreathProgress] = useState(0);
  const [cycleCount, setCycleCount] = useState(0);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = docHeight > 0 ? scrollTop / docHeight : 0;
      setScrollProgress(progress);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    let interval: ReturnType<typeof setInterval>;
    if (breathActive) {
      const step = breathingSteps[breathStep];
      const startTime = Date.now();
      interval = setInterval(() => {
        const elapsed = Date.now() - startTime;
        const progress = Math.min((elapsed / step.duration) * 100, 100);
        setBreathProgress(progress);
        if (elapsed >= step.duration) {
          if (breathStep < breathingSteps.length - 1) {
            setBreathStep((prev) => prev + 1);
            setBreathProgress(0);
          } else {
            setBreathStep(0);
            setBreathProgress(0);
            setCycleCount((prev) => prev + 1);
          }
        }
      }, 50);
    }
    return () => clearInterval(interval);
  }, [breathActive, breathStep]);

  const handleBreathToggle = () => {
    if (breathActive) {
      setBreathActive(false);
      setBreathStep(0);
      setBreathProgress(0);
    } else {
      setBreathActive(true);
      setBreathStep(0);
      setBreathProgress(0);
    }
  };

  return (
    <div className="min-h-screen bg-cream">
      <Navbar />

      {/* Reading Progress Bar */}
      <div className="fixed top-0 left-0 right-0 h-1 z-50">
        <div
          className="h-full bg-terracotta transition-all duration-150"
          style={{ width: `${scrollProgress * 100}%` }}
        />
      </div>

      {/* Hero — ahora más compacto y apretado */}
      <section className="relative pt-20 md:pt-28 pb-8 md:pb-14 px-6 md:px-10">
        <div className="w-full max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-6 lg:gap-10 items-center mb-6 md:mb-10">
            <div className="w-full lg:w-1/2">
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="inline-block bg-[#AAB7A3] text-white text-xs font-sans font-semibold px-3 py-1 rounded-full">
                  {t('rutina.tag1')}
                </span>
                <span className="inline-block bg-terracotta text-white text-xs font-sans font-semibold px-3 py-1 rounded-full">
                  {t('rutina.tag2')}
                </span>
                <span className="inline-block bg-sand text-[#3D2B1F] text-xs font-sans font-semibold px-3 py-1 rounded-full">
                  {t('rutina.tag3')}
                </span>
              </div>
              <h1 className="font-serif text-xl md:text-2xl lg:text-3xl font-bold text-[#8B6F5C] leading-tight mb-4">
                {t('rutina.title1')} {t('rutina.title2')} {t('rutina.title3')}
              </h1>
              <p className="font-sans text-sm md:text-base text-[#3D2B1F] leading-relaxed">
                Mamá y bebé, juntas, en calma. Cinco movimientos simples que transforman
                la energía del día en la ternura de la noche.
              </p>
            </div>
            {/* Imagen entera en horizontal, al mismo tamaño que el texto */}
            <div className="w-full lg:w-1/2 flex items-center justify-center">
              <img
                src="https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/930459e0-be6b-46ea-b540-6268b46b0679_compressed_ChatGPT-Image-11-ago-2026-10_04_28-p.m..webp"
                alt="Mercedes en rutina de relajación"
                className="w-full max-w-[270px] md:max-w-[336px] h-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Introducción — Hablando a la mamá agotada */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-white">
        <div className="w-full max-w-3xl mx-auto border border-[#C58D72]/30 rounded-2xl p-8 md:p-12">
          <p className="font-sans text-lg md:text-xl text-[#3D2B1F] leading-relaxed mb-4">
            Si estás leyendo esto con los ojos pesados, con el cuerpo dolorido de cargar, de mecer, de esperar, de no dormir...
          </p>
          <p className="font-sans text-lg md:text-xl text-[#3D2B1F] leading-relaxed mb-4">
            <strong>Esta rutina es para vos.</strong>
          </p>
          <p className="font-sans text-base text-[#3D2B1F] leading-relaxed mb-4">
            No necesitás energía extra. No necesitás saber de yoga. No necesitás que tu bebé esté quieto o colaborador. Solo necesitás diez minutos, una superficie cómoda, y la voluntad de estar presente con tu pequeño.
          </p>
          <p className="font-sans text-base text-[#3D2B1F] leading-relaxed mb-4">
            Lo que vas a hacer acá no es "ejercicio". Es un abrazo extendido. Es una conversación silenciosa entre dos cuerpos que se aman. Es una forma de decirle a tu bebé, sin palabras, que estás acá. Y de decirle a tu propio cuerpo, que también merece descansar.
          </p>
          <p className="font-sans text-base text-[#3D2B1F] leading-relaxed mb-8">
            El neurocientífico <strong>Daniel Siegel</strong> explica algo hermoso: cuando una mamá se calma, el sistema nervioso de su bebé siente esa calma y se regula también. No es magia. Es biología. Es amor hecho ciencia. Es lo que Siegel llama <strong>co-regulación</strong>: dos sistemas nerviosos, dos corazones, una misma melodía de calma.
          </p>
          <div className="flex items-center gap-4">
            <img
              src="https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/8dab2b06-c8b9-4438-99c8-13f745118b3d_compressed_images-18.webp"
              alt="Daniel J. Siegel"
              className="w-14 h-14 rounded-full object-cover flex-shrink-0"
            />
            <div>
              <p className="font-sans text-sm font-semibold text-[#3D2B1F]">Daniel J. Siegel, M.D.</p>
              <p className="font-sans text-xs text-[#5C4A3A]">Psiquiatra · Pionero en neurobiología interpersonal</p>
              <p className="font-sans text-xs text-[#5C4A3A]">Autor de The Developing Mind</p>
            </div>
          </div>
        </div>
      </section>

      {/* Breathing Exercise — Primer paso antes de los movimientos */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-[#4A3F35]">
        <div className="w-full max-w-3xl mx-auto text-center">
          <span className="inline-block font-sans text-xs font-semibold text-cream uppercase tracking-[0.2em] mb-4">
            {t('rutina.breath_tag')}
          </span>
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-white leading-tight mb-4">
            {t('rutina.breath_title')}
          </h2>
          <p className="font-sans text-base text-cream max-w-xl mx-auto mb-10">
            {t('rutina.breath_desc')}
          </p>

          {/* Breathing Circle */}
          <div className="relative w-64 h-64 mx-auto mb-10">
            <div
              className="absolute inset-0 rounded-full border-2 border-white/30 transition-all duration-300"
              style={{
                transform: breathActive
                  ? `scale(${breathStep === 0 ? 0.5 + breathProgress * 0.5 : breathStep === 1 ? 1 : breathStep === 2 ? 1 - breathProgress * 0.5 : 0.5})`
                  : 'scale(0.5)',
              }}
            />
            <div className="absolute inset-4 rounded-full bg-terracotta/20 flex items-center justify-center transition-all duration-300">
              <div className="text-center">
                <p className="font-serif text-3xl md:text-4xl font-bold text-white mb-1">
                  {breathingSteps[breathStep].name}
                </p>
                <p className="font-sans text-xs text-cream max-w-[180px] mx-auto leading-relaxed">
                  {breathingSteps[breathStep].instruction}
                </p>
              </div>
            </div>
            {/* Progress ring */}
            <svg className="absolute inset-0 w-full h-full -rotate-90" viewBox="0 0 100 100">
              <circle
                cx="50"
                cy="50"
                r="46"
                fill="none"
                stroke="rgba(255,255,255,0.3)"
                strokeWidth="2"
              />
              <circle
                cx="50"
                cy="50"
                r="46"
                fill="none"
                stroke="#C58D72"
                strokeWidth="2"
                strokeLinecap="round"
                strokeDasharray={`${breathProgress * 2.89} 289`}
                className="transition-all duration-100"
              />
            </svg>
          </div>

          {cycleCount > 0 && (
            <p className="font-sans text-sm text-cream mb-6">
              Ciclos completados: <span className="text-terracotta font-semibold">{cycleCount}</span>
            </p>
          )}

          <button
            onClick={handleBreathToggle}
            className={`inline-flex items-center gap-3 px-8 py-4 rounded-full font-sans text-sm font-semibold transition-all duration-300 whitespace-nowrap ${
              breathActive
                ? 'bg-white/10 text-white border border-white/30 hover:bg-white/20'
                : 'bg-terracotta text-white hover:bg-[#8B6F5C]'
            }`}
          >
            <i className={`${breathActive ? 'ri-pause-line' : 'ri-play-line'} text-lg`} />
            {breathActive ? 'Pausar' : 'Empezar ejercicio'}
          </button>

          {!breathActive && cycleCount === 0 && (
            <p className="font-sans text-xs text-cream mt-4">
              Son 4 pasos de 4-6 segundos. Al completar 6 ciclos, habrás respirado consciente durante 2 minutos.
            </p>
          )}
        </div>
      </section>

      {/* Los 5 Movimientos */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-cream">
        <div className="w-full max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block font-sans text-xs font-semibold text-terracotta uppercase tracking-[0.2em] mb-4">
              {t('rutina.movimientos_tag')}
            </span>
            <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#8B6F5C] leading-tight mb-4">
              {t('rutina.movimientos_title')}
            </h2>
            <p className="font-sans text-base text-[#3D2B1F] max-w-2xl mx-auto">
              Cada movimiento tiene una descripción cálida y una explicación neurocientífica simple.
              No hace falta hacerlos perfectos. Hace falta hacerlos juntas.
            </p>
          </div>

          {/* Tab Navigation */}
          <div className="flex flex-wrap gap-2 mb-8 md:mb-12 justify-center">
            {yogaMovements.map((movement, index) => (
              <button
                key={movement.id}
                onClick={() => setActiveMovement(index)}
                className={`inline-flex items-center gap-2 font-sans text-sm font-semibold px-5 py-3 rounded-full transition-all duration-300 whitespace-nowrap ${
                  activeMovement === index
                    ? 'bg-terracotta text-white shadow-sm'
                    : 'bg-white text-[#3D2B1F] hover:bg-sand/50 border border-sand/40'
                }`}
              >
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-white/20 text-xs font-bold">
                  {movement.id}
                </span>
                {movement.name}
              </button>
            ))}
          </div>

          {/* Active Movement Content */}
          <div className="bg-white rounded-3xl overflow-hidden border border-sand/40">
            <div className="p-6 md:p-10">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-[#AAB7A3]/15 text-[#AAB7A3]">
                  <i className={`${yogaMovements[activeMovement].icon} text-xl`} />
                </div>
                <div>
                  <span className="inline-block font-sans text-xs font-semibold text-terracotta uppercase tracking-wider">
                    {t('rutina.movimiento')} {yogaMovements[activeMovement].id} de 5 · {yogaMovements[activeMovement].duration}
                  </span>
                  <h3 className="font-serif text-2xl md:text-3xl font-bold text-[#8B6F5C] leading-tight">
                    {yogaMovements[activeMovement].name}
                  </h3>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                <div className="bg-cream rounded-2xl p-6">
                  <span className="inline-block font-sans text-xs font-semibold text-[#5C4A3A] uppercase tracking-wider mb-3">
                    {t('rutina.como_hacerlo')}
                  </span>
                  <p className="font-sans text-sm text-[#3D2B1F] leading-relaxed">
                    {yogaMovements[activeMovement].description}
                  </p>
                </div>
                <div className="bg-[#4A3F35] rounded-2xl p-6">
                  <span className="inline-block font-sans text-xs font-semibold text-cream uppercase tracking-wider mb-3">
                    {t('rutina.ciencia')}
                  </span>
                  <p className="font-sans text-sm text-cream leading-relaxed">
                    {yogaMovements[activeMovement].science}
                  </p>
                </div>
              </div>

              {/* Navigation arrows */}
              <div className="flex items-center justify-between mt-8 pt-6 border-t border-sand/30">
                <button
                  onClick={() => setActiveMovement((prev) => (prev > 0 ? prev - 1 : yogaMovements.length - 1))}
                  className="inline-flex items-center gap-2 font-sans text-sm font-semibold text-[#3D2B1F] hover:text-terracotta transition-colors duration-300"
                >
                  <i className="ri-arrow-left-line" />
                  {t('rutina.movimiento_anterior')}
                </button>
                <span className="font-sans text-xs text-[#5C4A3A]">
                  {activeMovement + 1} / {yogaMovements.length}
                </span>
                <button
                  onClick={() => setActiveMovement((prev) => (prev < yogaMovements.length - 1 ? prev + 1 : 0))}
                  className="inline-flex items-center gap-2 font-sans text-sm font-semibold text-[#3D2B1F] hover:text-terracotta transition-colors duration-300"
                >
                  {t('rutina.movimiento_siguiente')}
                  <i className="ri-arrow-right-line" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Cierre Emocional */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-white">
        <div className="w-full max-w-6xl mx-auto">
          {/* Recuadro salmón que abarca foto + texto */}
          <div className="border-2 border-[#C58D72]/40 rounded-2xl overflow-hidden">
            <div className="flex flex-col lg:flex-row">
              {/* Foto de Mercedes — izquierda, landscape y aún más chica */}
              <div className="w-full lg:w-[18%] flex-shrink-0">
                <div className="aspect-[16/10] lg:aspect-auto lg:h-full">
                  <img
                    src="https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/236b0b75-80dd-4873-abba-315bcf1441c5_compressed_ChatGPT-Image-10-ago-2026-12_30_43-a.m.-4.webp"
                    alt="Mercedes — NeuroBabys"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              {/* Texto — derecha, con más espacio y más compacto */}
              <div className="w-full lg:w-[82%] p-5 md:p-8 flex flex-col justify-center">
                <h2 className="font-serif text-lg md:text-xl font-bold text-[#8B6F5C] leading-tight mb-4 whitespace-nowrap">
                  {t('rutina.cierre_title1')} {t('rutina.cierre_title2')}
                </h2>

                <p className="font-sans text-sm md:text-base text-[#3D2B1F] leading-relaxed mb-3">
                  En estos diez minutos, no hiciste solo yoga. No hiciste solo ejercicios de respiración.
                </p>
                <p className="font-sans text-sm md:text-base text-[#3D2B1F] leading-relaxed mb-3">
                  En estos diez minutos, <strong>le enseñaste a tu bebé que el mundo es un lugar seguro.</strong> Que cuando se siente inquieto, hay un cuerpo que lo contiene. Que cuando el día fue intenso, hay una mama que sabe bajar la velocidad. Que descansar no es rendirse: es consentirse.
                </p>
                <p className="font-sans text-xs md:text-sm text-[#3D2B1F] leading-relaxed mb-3">
                  Quizás tu bebé se durmió durante la rutina. Quizás no. Quizás lloró un poco. Quizás te miró fijo como si te estuviera viendo por primera vez. No hay una "respuesta correcta". Cada bebé recibe el amor a su manera. Lo que importa es que estuviste ahí. Presente. Conectada. Cuerpo con cuerpo, alma con alma.
                </p>
                <p className="font-sans text-xs md:text-sm text-[#3D2B1F] leading-relaxed">
                  Te merecés descansar. Te merecés sentir que lo que estás haciendo es suficiente. <strong>Porque lo es.</strong>
                </p>
              </div>
            </div>
          </div>

          {/* Cita abajo, full width */}
          <div className="mt-10 md:mt-14 bg-cream rounded-3xl p-8 md:p-12 border border-sand/40 max-w-3xl mx-auto">
            <p className="font-serif text-xl md:text-2xl text-[#8B6F5C] italic leading-relaxed mb-6">
              "El amor no es algo que damos. Es algo que somos. Y cuando estamos con nuestro bebé en calma, ese amor se convierte en la medicina más poderosa que existe."
            </p>
            <p className="font-sans text-sm text-[#5C4A3A]">
              — El equipo de NeuroBabys
            </p>
          </div>
        </div>
      </section>

      {/* CTA al Programa Completo */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-cream">
        <div className="w-full max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#8B6F5C] leading-tight mb-4">
              El acompañamiento completo
            </h2>
            <p className="font-sans text-lg text-[#3D2B1F] max-w-2xl mx-auto">
              Esto es solo una muestra de lo que podés encontrar en nuestros programas.
              Elegí el que más se adapte a vos.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {programs.map((program) => (
              <div key={program.id} className="bg-white rounded-3xl overflow-hidden border border-sand/40">
                <div className="h-44 md:h-52 overflow-hidden">
                  <img
                    src={program.image}
                    alt={program.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6 md:p-8">
                  <div className="mb-3">
                    <h3 className="font-serif text-lg md:text-xl font-bold text-[#8B6F5C] leading-tight">
                      {program.title}
                    </h3>
                    <p className="font-sans text-xs text-[#5C4A3A] mt-1">{program.subtitle}</p>
                  </div>
                  <p className="font-sans text-sm text-[#3D2B1F] leading-relaxed mb-6">
                    {program.description}
                  </p>
                  <Link
                    to={program.id === 1 ? '/fundamentos-sueno' : program.id === 2 ? '/yoga-sueno-profundo' : '/programa-completo-neurobabys'}
                    className="inline-flex items-center font-sans text-sm font-semibold text-terracotta hover:text-[#8B6F5C] transition-colors duration-300"
                  >
                    Ver programa
                    <i className="ri-arrow-right-line ml-1" />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}